import { render } from "./InacticaItem.vue?vue&type=template&id=ef120908"
import script from "./InacticaItem.vue?vue&type=script&lang=js"
export * from "./InacticaItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__